import {useToast} from '../../shared/components/toast/useToast.js';
import {translate} from '../../shared/mixins/translation';

export const PaymentCanceled = () => {
    useToast().error(translate('app.administration.license.messages.subscription_canceled'));
    return {name: 'Home'};
};
